module.exports = __webpack_public_path__ + "static/media/selected-mobile.dddf83d6.svg";